import React from 'react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center" style={{
    backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/mBmNQYpRXcSvJS2TW9wSNp/raise_the_bar_june_2024-250.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  }} data-id="element-73">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60 z-0" data-id="element-74"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto flex flex-col items-center py-[120px] md:py-[160px]" data-id="element-75">
        <img src="https://cdn.magicpatterns.com/uploads/kHPY5hn7jL6QdVkj1vf8yR/raise_the_bar_white.png" alt="Raise The Bar Logo" className="w-[140px] md:w-[180px] mb-8" data-id="element-76" />

        <div className="relative inline-block" data-id="element-77">
          <h1 className="text-[32px] md:text-[52px] lg:text-[58px] text-white mb-6 leading-tight" style={{
          fontFamily: "'Playfair Display', serif",
          textShadow: '0 2px 8px rgba(0,0,0,0.5)'
        }} data-id="element-78">
            Empowering Your Beauty & Confidence
          </h1>
          {/* Shimmer effect */}
          <div className="absolute -inset-1 bg-gradient-to-r from-transparent via-[#C8A84E]/30 to-transparent blur-lg opacity-50 animate-[pulse_3s_ease-in-out_infinite] pointer-events-none" data-id="element-79"></div>
        </div>

        <p className="text-lg md:text-xl mb-10 tracking-wider max-w-2xl mx-auto leading-relaxed" style={{
        fontFamily: "'Montserrat', sans-serif",
        textShadow: '0 1px 4px rgba(0,0,0,0.4)'
      }} data-id="element-80">
          <span className="text-[#C8A84E]" data-id="element-81">
            Gilbert, Arizona's Premier Medical Spa
          </span>
          <span className="text-white" data-id="element-82">
            {' '}
            — Personalized Aesthetic Treatments by Licensed Professionals
          </span>
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full sm:w-auto" data-id="element-83">
          <a href="#book" className="w-full sm:w-auto bg-[#C8A84E] hover:bg-[#b39542] text-black px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 min-h-[52px] flex items-center justify-center" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} data-id="element-84">
            Book a Consultation
          </a>
          <a href="#services" className="w-full sm:w-auto bg-transparent border-2 border-[#C8A84E] text-white hover:bg-[#C8A84E]/10 px-8 py-4 rounded-full font-semibold transition-all duration-300 min-h-[52px] flex items-center justify-center" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} data-id="element-85">
            Explore Our Services
          </a>
        </div>
      </div>
    </section>;
}